import { WARN } from './constants';
var minLevel = WARN;
var getMinimumLogLevel = function () {
    return minLevel;
};
var setMinimumLogLevel = function (logLevel) {
    minLevel = logLevel;
};
export { getMinimumLogLevel, setMinimumLogLevel };
